<div class="tag d-flex align-items-center" (contextmenu)="$event.preventDefault()" (mouseenter)="isHover = true"
  (mouseleave)="isHover = false">
  <mat-slide-toggle [checked]="isActive" disableRipple (change)="screensStateService.tagItemChanged(tag, isActive)">
  </mat-slide-toggle>
  <mat-icon [ngStyle]="{ 'fill': tag.Color }" class="tag__icon mr-2" svgIcon="tag-icon"></mat-icon>
  <div class="tag__title" [matTooltip]="tag.Title">{{ tag.Title }}</div>
  <div class="tag__actions align-text-bottom align-items-center">
    <mat-icon [hidden]="!isHover" class="tag__action" svgIcon="edit" matTooltip="Edit tag" (click)="editTag()">
    </mat-icon>
    <mat-icon *ngIf="userId && tag.CreatorUserId == userId" [hidden]="!isHover" class="tag__action" svgIcon="close"
      matTooltip="Delete tag" (click)="removeTag()">
    </mat-icon>
  </div>
</div>